import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-6 md:px-12 max-w-6xl mx-auto overflow-hidden" data-id="element-86">
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-87">
        <div className="flex-1 text-center lg:text-left z-10" data-id="element-88">
          <div className="inline-block mb-4 px-4 py-1.5 bg-sage-light/50 text-sage-dark font-semibold rounded-full text-sm tracking-wide uppercase" data-id="element-89">
            Protocolo Vientre Plano 40+
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-90">
            Cierra el botón de tu pantalón favorito en solo 14 días
            <span className="block text-2xl md:text-3xl lg:text-4xl text-sage-dark mt-4 font-medium italic" data-id="element-91">
              (sin hacer horas de cardio ni pasar hambre)
            </span>
          </h1>
          <h2 className="text-lg md:text-xl text-charcoal-light mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0 font-sans" data-id="element-92">
            El protocolo antiinflamatorio diseñado para mujeres de 40+ que
            sufren de "barriga de menopausia" y quieren recuperar su cintura
            apagando el interruptor del cortisol.
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-93">
            <a href="#pricing" className="btn-primary w-full sm:w-auto group" data-id="element-94">
              ¡SÍ, QUIERO MI VIENTRE PLANO AHORA!
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-95" />
            </a>
          </div>
          <div className="mt-6 flex items-center justify-center lg:justify-start gap-2 text-sm text-charcoal-light" data-id="element-96">
            <span className="flex text-gold" data-id="element-97">★★★★★</span>
            <span data-id="element-98">Basado en ciencia hormonal para latinas</span>
          </div>
        </div>

        <div className="flex-1 relative w-full max-w-md lg:max-w-none mx-auto" data-id="element-99">
          <div className="absolute inset-0 bg-sage-light rounded-full blur-3xl opacity-30 transform translate-x-10 translate-y-10" data-id="element-100"></div>
          <img src="https://cdn.magicpatterns.com/uploads/r6KrRm7qJ41P5jBQEYt9de/Imagen1mockup.png" alt="Protocolo Vientre Plano 40+ en iPad" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-101" />
        </div>
      </div>
    </section>;
}